// noinspection JSUnusedGlobalSymbols

import _ from "lodash";

import {HttpStatus} from "@isudio/core";
import {DbModel, Audit, type IAudit} from "./db.model";
import {AuditTypes, DocPrefix, DocTypes} from "../constants";
import {ConsentActions, ConsentTypes} from "../constants";

export interface IConsent {
  type: ConsentTypes;
  version: number;
  title?: string;
  message?: object;
  urls?: Array<object>;
  mandatory?: boolean;
  action?: ConsentActions;
}

export interface IConsents {
  consents: Array<IConsent>;
}

export class Consents extends DbModel implements IConsents {
  consents: Array<IConsent>;

  constructor(private data?: any) {
    super();

    const id = _.get(this.data, '_id', DocPrefix.consents + _.shortID(DocTypes.consents));
    this._id = _.get(this.data, '_id', id);
    this.type = DocTypes.consents;
    this.consents = _.get(this.data, 'consents', []);
    this.audit = _.omitBy(new Audit(this.data, AuditTypes.created), _.isNil) as IAudit;
  }
}

export interface ISearch {
  query: string;
  dbName: string;
  filters?: Array<any>;
  includeDocs?: boolean;
  limit?: number;
}

export interface ISearchResponse {
  status: HttpStatus;
  message: string;
  count: number;
  result: Array<any>;
  docs: Array<any>;
}

export interface ResizedMedia {
  "default": string;
  "size-xs": string;
  "size-sm": string;
  "size-md": string;
  "size-lg": string;
  "size-xl": string;
  "size-xxl": string;
}

export interface MediaObject {
  key: string;
  mimeType: string;
  url: string;
  thumbnail?: string;
  resized?: ResizedMedia;
}
